import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { Checkbox } from 'primeng/checkbox'
import { createFormControlBinding, FieldGroup } from '@core/utils/form-utils'

@Component({
  selector: 'albert-checkbox',
  standalone: true,
  imports: [ReactiveFormsModule, Checkbox],
  templateUrl: './albert-checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AlbertCheckboxComponent {
  public readonly groupName = input.required<string>()
  public readonly label = input.required<string>()
  public readonly inputId = input.required<string>()
  public readonly controlName = input<string>('value')
  public readonly placeholder = input<string>('')
  public readonly disabled = input<boolean>(false)

  private readonly parentGroupDir = inject(FormGroupDirective)
  private readonly binding = createFormControlBinding(this.groupName, this.controlName, this.disabled)

  public readonly control = this.binding.control

  public get isUpdatedByOrigami(): boolean {
    return this.binding.isUpdatedByOrigami()
  }

  private get group(): FieldGroup<boolean> | null {
    return this.parentGroupDir.form.get(this.groupName()) as FieldGroup<boolean> | null
  }
}
